import { Link } from "react-router-dom";
import { getRelatedPosts } from "@/content/posts";
import PostCard from "./PostCard";

const RelatedPosts = ({ slug }: { slug: string }) => {
  const related = getRelatedPosts(slug, 3);
  if (!related.length) return null;
  return (
    <section className="mt-16 border-t border-border pt-12">
      <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-6">
        Keep reading
      </h2>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {related.map((p) => (
          <PostCard key={p.slug} post={p} />
        ))}
      </div>
    </section>
  );
};

export default RelatedPosts;
